/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for a planning day
 * @export
 * @interface PlanningDayResponse
 */
export interface PlanningDayResponse {
    /**
     * Unique identifier of the day planning
     * @type {string}
     * @memberof PlanningDayResponse
     */
    dayId?: string;
    /**
     * Name of the day planning
     * @type {string}
     * @memberof PlanningDayResponse
     */
    name?: string;
    /**
     * Number of the day planning
     * @type {number}
     * @memberof PlanningDayResponse
     */
    number?: number;
    /**
     * Status of day planning
     * @type {boolean}
     * @memberof PlanningDayResponse
     */
    active?: boolean;
}

/**
 * Check if a given object implements the PlanningDayResponse interface.
 */
export function instanceOfPlanningDayResponse(value: object): value is PlanningDayResponse {
    return true;
}

export function PlanningDayResponseFromJSON(json: any): PlanningDayResponse {
    return PlanningDayResponseFromJSONTyped(json, false);
}

export function PlanningDayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanningDayResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dayId': json['dayId'] == null ? undefined : json['dayId'],
        'name': json['name'] == null ? undefined : json['name'],
        'number': json['number'] == null ? undefined : json['number'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function PlanningDayResponseToJSON(json: any): PlanningDayResponse {
    return PlanningDayResponseToJSONTyped(json, false);
}

export function PlanningDayResponseToJSONTyped(value?: PlanningDayResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayId': value['dayId'],
        'name': value['name'],
        'number': value['number'],
        'active': value['active'],
    };
}

